
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (item.__type == 'danma') { 
    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"danma\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>\n      </div>\n      <div class=\"c-scrollview__content\">\n        ")
    ; __append(escape(item.content))
    ; __append("\n      </div>\n    </div>\n  </section>\n")
    ;  } 
    ; __append("\n")
    ;  if (item.__type == 'praise') { 
    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"praise\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
    ; __append(escape(item.nickname))
    ; __append("：</em>\n      </div>\n      ")
    ;  if (item.praise_type == '2') { 
    ; __append("\n        <div class=\"c-scrollview__content\">\n          给主播点了赞！\n        </div>\n      ")
    ;  } 
    ; __append("\n      ")
    ;  if (item.praise_type == '3') { 
    ; __append("\n        <div class=\"c-scrollview__content\">\n          点燃一根蜡烛\n        </div>\n      ")
    ;  } 
    ; __append("\n    </div>\n  </section>\n")
    ;  } 
    ; __append("\n")
    ;  if (item.__type == 'gift') { 
    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"gift\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.user.avatar)))
    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
    ; __append(escape(item.user.nickname))
    ; __append("：</em>\n      </div>\n      <div class=\"c-scrollview__content\">\n        赠送了<span class=\"c-scrollview__giftname\">")
    ; __append(escape(item.gift.desc))
    ; __append("</span><span class=\"c-scrollview__giftpic\" style=\"background-image: url(")
    ; __append(escape(item.gift.src))
    ; __append(")\"></span>\n      </div>\n    </div>\n  </section>\n")
    ;  } 
    ; __append("\n")
    ;  if (item.__type == 'online') { 
    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
    ; __append(escape(item.id))
    ; __append("\" data-type=\"online\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></span>\n        <span class=\"c-scrollview__online\">欢迎 ")
    ; __append(escape(item.nickname))
    ; __append(" 进入直播间</span>\n      </div>\n    </div>\n  </section>\n")
    ;  } 
    ; __append("\n")
    ;  if (item.__type == 'system') { 
    ; __append("\n  <section class=\"c-scrollview__item\" data-type=\"system\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
    ; __append(escape(decodeURIComponent(item.avatar)))
    ; __append(")\"></span>\n        <span class=\"c-scrollview__online\">")
    ; __append(escape(item.content))
    ; __append("</span>\n      </div>\n    </div>\n  </section>\n")
    ;  } 
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/scrollview/item.ejs
// module id = 603
// module chunks = 0